import KycFormRejected from "../components/KycFormRejected";

const KycVerificationRejected = () => (
  <div className="relative z-10 w-full max-w-md px-6 py-8">
    <div className="mb-8 flex justify-center">
      <img
        src="/rejected-icon.svg"
        alt="kyc rejected"
        className="h-[129px] w-[121px]"
      />
    </div>
    <KycFormRejected />
  </div>
);

export default KycVerificationRejected;
